import { PendingTopup, TopupWithState } from '@/src/api/payg';
import { PAYG_EVENTS } from '@/src/constants/analytics';
import AnalyticsService from '@/src/services/analyticsService';
import React, { useEffect } from 'react';
import { getTopupProcessingCopy } from '../../utils/topupCopyHelpers';
import { NotificationCard } from './NotificationCard';

type UnpaidAndProcessingTopup = TopupWithState<
  PendingTopup,
  'PROCESSING' | 'PENDING_PAYMENT' | 'AUTO_APPLY_DELAYED'
>;

type Props = {
  topup: UnpaidAndProcessingTopup;
};

export const ProcessingNotification = ({ topup }: Props) => {
  useEffect(() => {
    AnalyticsService.dispatch(
      ...PAYG_EVENTS.postPaymentAlertDisplayed({
        state: topup.state,
        topupSessionId: topup.topupSessionId,
      }),
    );
  }, [topup.state, topup.topupSessionId]);

  const copy = getTopupProcessingCopy({
    state: topup.state,
    fuel: topup.fuel,
    minutes:
      'expectedMinsToAutoApply' in topup
        ? topup.expectedMinsToAutoApply
        : undefined,
  });

  return (
    <NotificationCard id={topup.topupSessionId} variant="info" copy={copy} />
  );
};
